import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

export const createCustomContentPillar = createAsyncThunk(
  "customContentPillar/create",
  async ({ clientId, name, description, target }, { getState, rejectWithValue }) => {
    try {
      const state = getState()
      if (!state.auth?.token) throw new Error("Authentication required")
      if (!clientId) throw new Error("Client ID is required")
      if (!String(name || "").trim()) throw new Error("Pillar name is required")

      const parsedTarget =
        typeof target === "number" && !Number.isNaN(target)
          ? target
          : Number.parseInt(target, 10) || 0

      const payload = {
        name: String(name).trim(),
        description: String(description || name).trim(),
        target: Math.max(0, Math.min(20, parsedTarget)),
      }

      // Matches API contract used in curl:
      // POST /api/v1/content-pillar/clients/{clientId}
      const data = await post(`content-pillars/clients/${clientId}`, payload)
      return data
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to create content pillar")
    }
  },
)

const initialState = {
  status: "idle",
  error: null,
}

const customContentPillarSlice = createSlice({
  name: "customContentPillar",
  initialState,
  reducers: {
    clearCustomContentPillarError: (state) => {
      state.error = null
    },
    resetCustomContentPillarState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createCustomContentPillar.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(createCustomContentPillar.fulfilled, (state) => {
        state.status = "succeeded"
      })
      .addCase(createCustomContentPillar.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload || "Failed to create content pillar"
      })
  },
})

export const { clearCustomContentPillarError, resetCustomContentPillarState } =
  customContentPillarSlice.actions

export default customContentPillarSlice.reducer
